import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import Modal from "../Home/Modal";
import { IStore } from "../../redux/store/IStore";
import { useDispatch, useSelector } from "react-redux";
import { setWordBoostModal } from "../../redux/actions/actions";
import Search from "@material-ui/icons/Search";
import { BoostedPhrasesList, deleteBoostPhrase, getBoostedPhrases, IBoostedPhrase, ILocalBoostedPhrase, LocalBoostedPhrasesList, patchBoostPhrase, postBoostedPhrase } from "../../api/WordBoostService";
import Tooltip from "@material-ui/core/Tooltip";
import { enqueueSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import UndoIcon from '@material-ui/icons/Undo';
import './word_boost.css'

const initialBoostPhrase = {id: -1, boost: "0", phrase: ""}

const WordBoostModal = () => {
    const dispatch = useDispatch();
    
    const [boostedWordsFilter, setBoostedWordsFilter] = useState<string>("")
    const [phrasesDeletedIds, setPhrasesDeletedIds] = useState<number[]>([])
    const [boostedPhrasesList, setBoostedPhrasesList] = useState<LocalBoostedPhrasesList>([])
    const [newBoostPhrase, setNewBoostPhrase] = useState<ILocalBoostedPhrase>(initialBoostPhrase)

    const originalBoostedPhraseList = useRef<LocalBoostedPhrasesList>([])
    const boostedWordFileInputRef = useRef<HTMLInputElement>(null);
    const [updating, setUpdating] = useState<boolean>(false)
    
    const {
        visible,
    } = useSelector((store: IStore) => store.wordBoostModal);

    const hideWordBoostModal = () => dispatch(setWordBoostModal({
        visible: false,
    }))

    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
        setBoostedWordsFilter(event.target.value)
    }

    const handleExistingPhraseChange = (event: ChangeEvent<HTMLInputElement>, id: number) => {
        setBoostedPhrasesList(current => current.map((item, i) => item.id === id ? { ...item, phrase: event.target.value } : item ));
    }

    const handleExistingPhraseBoostChange = (event: ChangeEvent<HTMLInputElement>, id: number) => {
        setBoostedPhrasesList(current => current.map((item, i) => item.id === id ? { ...item, boost: event.target.value } : item ));
    }

    const recoverDeletedBoostedWord = (id: number) => {
        setPhrasesDeletedIds(current => current.filter(iterationId => iterationId !== id))
    }

    const deleteBoostedWord = (id: number) => {
        setPhrasesDeletedIds(current => [...current, id]);
    }

    const handlePhraseChange = (event: ChangeEvent<HTMLInputElement>) => {
        setNewBoostPhrase({...newBoostPhrase, phrase: event.target.value})
    }

    const handlePhraseBoostChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Allow empty input (e.g., user is typing or clearing the field)
        /*if (value === '' || value === '-') {
          setNewBoostPhrase({ ...newBoostPhrase, boost: value });
          return;
        }
    
        const parsed = parseInt(value, 10);
    
        if (!isNaN(parsed)) {
        }*/
        setNewBoostPhrase({ ...newBoostPhrase, boost: event.target.value });
    };

    const addWordToList = () => {
        setBoostedPhrasesList(current => {
          const boostExists = current.filter(boostPhrase => boostPhrase.phrase === newBoostPhrase.phrase).length > 0
          if (boostExists) {
            enqueueSnackbar("Beseda že obstaja.", { variant: "error" })
            return current;
          }
          current.push({...newBoostPhrase, id: -Date.now()})
          setNewBoostPhrase(initialBoostPhrase)
          return current;
        })
    }

    const importBoostTsv = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;
    
        const reader = new FileReader();
        reader.onload = (e) => {
          const text = e.target?.result as string;
          const lines = text.trim().split('\n');
    
          const newList: LocalBoostedPhrasesList = [];
    
          if (lines.length < 2) {
            enqueueSnackbar("Datoteka ni v veljavnem formatu!", {variant: 'error'})
            return
          };
          
          const line = lines[0];
          const splitter = /\t/;
          const [headerSource, headerTarget] = line.split(splitter, 2);
          if (headerSource !== "phrase" && headerTarget !== "boost") {
            enqueueSnackbar("Datoteka ni v veljavnem formatu!", {variant: 'error'})
            return;
          }

          for (let i = 1; i < lines.length; i++) {
            const line = lines[i];
            const splitter = /\t/;
            const [rawPhrase, rawBoost] = line.split(splitter, 2);;
    
            if (!rawPhrase || isNaN(parseInt(rawBoost))) continue;
    
            newList.push({
              id: -(Date.now() + i),
              phrase: rawPhrase,
              boost: rawBoost
            });
          }
    
          setBoostedPhrasesList((prevList) => {
            const phraseMap = new Map<string, ILocalBoostedPhrase>();
    
            prevList.forEach(item => phraseMap.set(item.phrase, { ...item }));
    
            newList.forEach(item => {
              if (phraseMap.has(item.phrase)) {
                phraseMap.get(item.phrase)!.boost = item.boost;
                //phraseMap.get(item.phrase)!.id = item.id;
              } else {
                phraseMap.set(item.phrase, item);
              }
            });
    
            return Array.from(phraseMap.values());
          });
        };
    
        reader.readAsText(file);
    }

    const exportBoostedPhrasesToTSV = (data: BoostedPhrasesList) => {
        const header = "phrase\tboost";
        const rows = data.map(item => `${item.phrase}\t${item.boost}`);
        return [header, ...rows].join('\n');
    }

    const exportBoostTsv = useCallback(() => {
        const tsvContent = exportBoostedPhrasesToTSV(boostedPhrasesList);
    
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const filename = `osebni_slovar_${pad(now.getDate())}_${pad(now.getMonth() + 1)}_${now.getFullYear()}_${pad(now.getHours())}_${pad(now.getMinutes())}.tsv`;
    
        const blob = new Blob([tsvContent], { type: 'text/tab-separated-values;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        link.click();
    
        URL.revokeObjectURL(url); // Clean up
    }, [boostedPhrasesList])


    const boostedPhrasesWrapper = async () => {
        try {
          const response = await getBoostedPhrases();
          const sorted = [...response.data].sort((a, b) => a.phrase.localeCompare(b.phrase, 'sl'));
          sorted.forEach(row => row.boost = `${row.boost}`)
          originalBoostedPhraseList.current = sorted as LocalBoostedPhrasesList
          setBoostedPhrasesList(sorted as LocalBoostedPhrasesList)
          setPhrasesDeletedIds([])
        } catch (error) {
          console.log(error);
        }
    }

    const saveBoosts = async () => {
        setUpdating(true);
        try {
          const filterExistingToDelete = phrasesDeletedIds.filter(id => id > -1);
          const newBoosts = boostedPhrasesList.filter(boostedPhrase => boostedPhrase.id < 0)
          const filterExistingToPatch = boostedPhrasesList.filter(boostedPhrase => boostedPhrase.id > -1)
          
          for (let deleteBoostIndex = 0; deleteBoostIndex < filterExistingToDelete.length; deleteBoostIndex++) {
            await deleteBoostPhrase(filterExistingToDelete[deleteBoostIndex])
          }
          
          for (let newBoostIndex = 0; newBoostIndex < newBoosts.length; newBoostIndex++) {
            if (phrasesDeletedIds.includes(newBoosts[newBoostIndex].id)) continue;
            await postBoostedPhrase(newBoosts[newBoostIndex])
          }
    
          for (let patchBoostIndex = 0; patchBoostIndex < filterExistingToPatch.length; patchBoostIndex++) {
            const boostPhrase = boostedPhrasesList[patchBoostIndex]        
            if (filterExistingToDelete.includes(boostPhrase.id)) continue;
            
            const original = originalBoostedPhraseList.current.find(iterationBoostPhrase => iterationBoostPhrase.id === boostPhrase.id)
            if (!original) continue;
            
            let updateObj = {id: boostPhrase.id}
            if (original.boost === boostPhrase.boost && original.phrase === boostPhrase.phrase) continue;
            if (original.boost !== boostPhrase.boost) updateObj["boost"] = boostPhrase.boost
            if (original.phrase !== boostPhrase.phrase) updateObj["phrase"] = boostPhrase.phrase
            
            await patchBoostPhrase(updateObj)
          }
    
          await boostedPhrasesWrapper();
        } catch (error) {
          console.log(error)
        }
        setUpdating(false);
    }

    useEffect(() => {
        if (visible) {
          boostedPhrasesWrapper();
        }
    }, [visible])
      
    return (
    <Modal visible={visible} title='Osebni slovar' closeModal={hideWordBoostModal}>
        <div id="word-boost-container">
          <div id="boost-toolbar-container">
            <Search />
            <input id="word-boost-filter-field" placeholder='Išči...' value={boostedWordsFilter} onChange={handleFilterChange}/>
          </div>
          
          <div id="boost-table-container">
            <table id="boost-table">
              <thead>
                <tr>
                  <th className='boost-th'>Tekst</th>
                  <th className='boost-th'>Utež</th>
                  <th className='boost-th'>Akcije</th>
                </tr>
              </thead>
              <tbody>
                {boostedPhrasesList.filter(boostedPhrase => boostedPhrase.phrase.toLowerCase().includes(boostedWordsFilter.toLowerCase())).map(boostedPhrase => {
                  const isLocalyDeleted = phrasesDeletedIds.includes(boostedPhrase.id)
                  const newelyAdded = boostedPhrase.id < 0
                  let backgroundColor = "transparent"
                  const originalBoostPhrase = originalBoostedPhraseList.current.filter(current => current.id === boostedPhrase.id)
                  
                  console.log("originalBoostPhrase")
                  console.log(originalBoostPhrase)
                  console.log("boostedPhrase")
                  console.log(boostedPhrase)
                  
                  if (originalBoostPhrase.length > 0 && (originalBoostPhrase[0].phrase !== boostedPhrase.phrase || originalBoostPhrase[0].boost !== boostedPhrase.boost)) {
                    backgroundColor = "#fff7c29a"
                  }
                  
                  if (newelyAdded) backgroundColor = "#31a0ff3f"
                  if (isLocalyDeleted) backgroundColor = "#ff66663f"

                  return (
                    <tr style={{ backgroundColor }}>
                      <td className='boost-td'>
                        <input disabled={isLocalyDeleted} onChange={event => handleExistingPhraseChange(event, boostedPhrase.id)} value={boostedPhrase.phrase}/>
                      </td>
                      <td className='boost-td'>
                        <input type="number" step="1" disabled={isLocalyDeleted} onChange={event => handleExistingPhraseBoostChange(event, boostedPhrase.id)} value={boostedPhrase.boost}/>
                      </td>
                      <td className='boost-td'>
                        {isLocalyDeleted && (
                          <Tooltip title="Ponastavi" arrow placement='top'>
                            <button onClick={() => recoverDeletedBoostedWord(boostedPhrase.id)}>
                              <UndoIcon />
                            </button>
                          </Tooltip>
                        ) || (
                          <Tooltip title="Izbriši" arrow placement='top'>
                            <button onClick={() => deleteBoostedWord(boostedPhrase.id)}>
                              <DeleteIcon className='delete_word_boost_icon' />
                            </button>
                          </Tooltip>
                        )}
                      </td>
                    </tr>
                  )
                })}
                <tr>
                  <td className='boost-td'>
                    <input placeholder='Vnesite besedo...' onChange={handlePhraseChange} value={newBoostPhrase.phrase} />
                  </td>
                  <td className='boost-td'>
                    <input type="number" step="1" placeholder="Vnesite utež..." onChange={handlePhraseBoostChange} value={newBoostPhrase.boost} />
                  </td>
                  <td className='boost-td'>
                    <Tooltip title="Dodaj besedo" arrow placement='top'>
                      <button onClick={addWordToList}>
                        <AddIcon id="add_word_boost_icon" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div id="word_boost_footer">
            <input
              type="file"
              accept=".tsv"
              ref={boostedWordFileInputRef}
              onChange={importBoostTsv}
              style={{ display: 'none' }} />
            <button disabled={updating} onClick={exportBoostTsv} className='button_boost_secondary'>Izvozi</button>
            <button disabled={updating} onClick={() => boostedWordFileInputRef.current?.click()} className='button_boost_secondary'>Naloži</button>
            <button disabled={updating} onClick={saveBoosts} className='button_boost_primary'>Shrani</button>
          </div>
          </div>
      </Modal>
    )
}

export default WordBoostModal;